import { useSchedule } from '@app/components/Schedule/hooks/useSchedule';
import { Schedule } from '@app/components/Schedule/Schedule';

export { Schedule, useSchedule };
